import React from "react";

// OTB ENT. mascot — character climbs in & out of the box, looping. Bottom-center.
export default function BoxMascot() {
  return (
    <div
      data-testid="otb-mascot"
      aria-hidden
      className="hidden sm:block fixed bottom-1 left-1/2 -translate-x-1/2 z-[55] pointer-events-none"
      style={{ width: 126, aspectRatio: "817 / 541", overflow: "hidden" }}
      title="OTB ENT."
    >
      {/* character (behind, animated) */}
      <img
        src="/otb_char.png"
        alt=""
        className="absolute inset-0 w-full h-full object-contain animate-climb"
        style={{ zIndex: 1 }}
      />
      {/* box (front, static) */}
      <img
        src="/otb_box.png"
        alt="OTB ENT."
        className="absolute inset-0 w-full h-full object-contain"
        style={{ zIndex: 2 }}
      />
    </div>
  );
}
